import { IMicrosoftAuthGetters } from './getters.types';

export const getters: IMicrosoftAuthGetters = {};
